var container = '_5l35j1';
var overlay = '_5l35j0';
var scrollArrow = '_5l35j2';

export { container, overlay, scrollArrow };
//# sourceMappingURL=select-primitive.css.js.map
